module.exports = __webpack_public_path__ + "assets/img/google.432eec2c.svg";